import {
  CheckPromoCode,
  CheckPromoCodeMyTicker,
  CheckPromoCodeResponse,
} from 'entities/promo-code/model'
import { ValidationResponse } from 'entities/ticket/ui/purchase-from/model.ts'

import {
  ApplyCertificateResponse,
  BuyTicket,
  BuyTicketResponse,
  CertificateResponse,
  DetailsAppeal,
  LastSearches,
  PaymentResult,
} from 'shared/api/BuyTicketModel.ts'
import {
  CurrentPriceOfTicket,
  MyTicketItem,
} from 'shared/api/MyTicketsModel.ts'
import { PassportItem } from 'shared/api/PassportInfo.ts'
import { refreshOrdersCount } from 'shared/api/orders-count-query'
import { Response } from 'shared/models/general.ts'

import { clientApi } from './clientApi'

export type ConfirmTypePay =
  | 'tickets'
  | 'flight_appeals'
  | 'excursion_orders'
  | 'bus_ticket_order'
  | 'umra'
  | 'insurance'
  | 'tours'
  | 'kyrgyzstan_orders' //TODO: поменять ключ
  | 'esim'

export interface ConfirmData {
  type: ConfirmTypePay
  id: string
  promocode_id?: string
  price?: string
}

export interface BuyTicketByPromoCode {
  id: string
  type: ConfirmTypePay
  promocode_id: string
  payment_provider: 9
}

export interface BuyTicketByPromoCodeResponse {
  payment_id: string
  payment_provider: number
  status: number
}

const isDev = import.meta.env.VITE_PROJECT_IS_DEV

export const BuyTicketApi = {
  async buyTicket(data: BuyTicket) {
    const response = await clientApi.post<Response<BuyTicketResponse>>(
      '/flights/tickets',
      data,
    )
    void refreshOrdersCount()
    return response
  },
  buyTicketConfirm(data: ConfirmData) {
    return clientApi.post<PaymentResult>(
      isDev
        ? '/flights/tickets/confirm'
        : 'https://webview.mtravel.kg/api/v1/flights/tickets/confirm',
      data,
    )
  },

  buyTicketByCertificate(data: BuyTicketByPromoCode) {
    return clientApi.post<BuyTicketByPromoCodeResponse>(
      '/payments/promotion/confirm',
      data,
    )
  },

  getDetailTicket(id: string) {
    return clientApi.get<Response<MyTicketItem>>(`/flights/tickets/${id}`)
  },
  searchesTicket() {
    return clientApi.get<Response<LastSearches[]>>('/flights/searches')
  },
  getAppealInfo(billingNumber: string) {
    return clientApi.get<Response<DetailsAppeal[]>>(
      `/flights/appeal/ticket/info/${billingNumber}`,
    )
  },
  getCurrentPriceOfTicket(tid: string) {
    return clientApi.get<Response<CurrentPriceOfTicket>>(
      `/flights/book-check-price/${tid}`,
    )
  },
  getValidation(data: BuyTicket) {
    return clientApi.post<Response<ValidationResponse>>(
      '/flights/validate/tickets',
      data,
    )
  },
  getSerialDocumentInfo() {
    return clientApi.get<Response<PassportItem[]>>(`/flights/validate/tickets`)
  },
  onBuyTicketByCertificate(data: { service_id: string }) {
    return clientApi.post<Response<ApplyCertificateResponse>>(
      '/certificate/apply',
      data,
    )
  },

  onBuyTicketByConfirm(data: { service_id: string }) {
    return clientApi.post<Response<ApplyCertificateResponse>>(
      '/certificate/confirm',
      data,
    )
  },

  onCheckStatusCertificate(certificate: string) {
    return clientApi.get<Response<CertificateResponse>>(
      `/certificate/status?service_id=${certificate}`,
    )
  },

  checkPromoCode(body: CheckPromoCode | CheckPromoCodeMyTicker) {
    return clientApi.post<Response<CheckPromoCodeResponse>>(
      `/ads/promocode/info`,
      body,
    )
  },
}
